import { Select } from 'antd';
import { AI_PROVIDER_LABELS, type AiStatus } from '@crm/shared';

/** Models from every configured provider, grouped by provider. */
export function AiModelSelect({ status, value, onChange, loading, allowClear, placeholder }: { status?: AiStatus; value?: string | null; onChange: (v: string | null) => void; loading?: boolean; allowClear?: boolean; placeholder?: string }) {
  const groups = (status?.providers ?? [])
    .filter((p) => p.configured)
    .map((p) => ({ label: AI_PROVIDER_LABELS[p.provider], title: p.provider, options: (status?.models ?? []).filter((m) => m.provider === p.provider).map((m) => ({ value: m.ref, label: m.label })) }))
    .filter((g) => g.options.length);
  return (
    <Select
      aria-label="AI model"
      showSearch
      optionFilterProp="label"
      allowClear={allowClear}
      loading={loading}
      style={{ width: '100%' }}
      value={value ?? undefined}
      onChange={(v) => onChange((v as string | undefined) ?? null)}
      options={groups}
      placeholder={placeholder ?? 'Choose a model'}
      notFoundContent="No models available"
    />
  );
}
